import { API, APIResponse } from "@/components/_Shared/API/API"
import { InvoiceProps } from "../interfaces/invoices_types"

export async function getInvoices(): Promise<APIResponse<InvoiceProps[]>> {
    const response = await API.get<InvoiceProps[]>('/api/invoice/')
    return response
}

export async function createInvoice(invoice: InvoiceProps): Promise<APIResponse> {
    const response = await API.post<void>("/api/invoice/", invoice)
    return response
}

export async function createBulkInvoices(invoices: InvoiceProps[]): Promise<APIResponse> {
    const response = await API.post<void>("/api/invoice/create_bulk", {invoices})
    return response
}

export async function getInvoiceById(invoice_id: string): Promise<APIResponse<InvoiceProps>> {
    const response = await API.get<InvoiceProps>(`/api/invoice/id/${invoice_id}`)
    return response
}

export async function getInvoiceByProjectId(project_id: string): Promise<APIResponse<InvoiceProps[]>> {
    const response = await API.get<InvoiceProps[]>(`/api/invoice/project/${project_id}`)
    return response
}

export async function updateInvoice(invoice: InvoiceProps): Promise<APIResponse> {
    const response = await API.put<void>(`/api/invoice/id/${invoice.invoice_id}`, invoice)
    return response
}

export async function deleteInvoice(invoice_id: string): Promise<APIResponse> {
    const response = await API.delete<void>(`/api/invoice/id/${invoice_id}`)
    return response
}

export async function getInvoicesNotPaid(): Promise<APIResponse<InvoiceProps[]>> {
    const response = await API.get<InvoiceProps[]>('/api/invoice/not_paid')
    return response
}

export async function markInvoiceAsSent(invoice_id: string): Promise<APIResponse> {
    const encodedID = encodeURIComponent(invoice_id)
    const response = await API.put<void>(`/api/invoice/mark_as_sent/${encodedID}`)
    return response 
}

export async function markProjectAsSentToQuickbooks(project_id: string): Promise<APIResponse> {
    const encodedID = encodeURIComponent(project_id)
    const response = await API.put<void>(`/api/invoice/mark_project_as_sent_to_quickbooks/${encodedID}`)
    return response
}
